import styled, { css } from "styled-components";
import { useDesignTokens } from "@boi/react-design-tokens";
import { CoreProgressIndicator } from "@boi/components-core";
import { Typography } from "../Typography";

type SegmentProps = {
  $backgroundVariant: CoreProgressIndicator.BackgroundVariant;
  $isFilled: boolean;
  $isFirst: boolean;
  $isLast: boolean;
};

export const Label = styled(Typography)`
  ${() => {
    const {
      tokens: { progressIndicator },
    } = useDesignTokens();
    return css`
      color: ${progressIndicator.label.text.color};
      margin-bottom: ${progressIndicator.label.marginBottom};
    `;
  }}
`;

export const Wrapper = styled.div`
  ${() => {
    const { tokens } = useDesignTokens();
    const { progressIndicator, breakpoint } = tokens;
    return [
      css`
        display: flex;
        gap: ${progressIndicator.segments.gap.mobile};
        @media (min-width: ${breakpoint.tablet}) {
          gap: ${progressIndicator.segments.gap.tablet};
        }
      `,
    ];
  }}
`;

export const Segment = styled.div<SegmentProps>`
  ${({ $backgroundVariant, $isFilled, $isFirst, $isLast }) => {
    const { tokens } = useDesignTokens();
    const { progressIndicator, breakpoint } = tokens;
    const { segment } = progressIndicator.segments;

    return [
      css`
        flex: 1;
        border-radius: ${segment.radius};
        height: ${segment.height.mobile};

        @media (min-width: ${breakpoint.tablet}) {
          height: ${segment.height.tablet};
        }
      `,
      $isFilled
        ? css`
            background-color: ${segment.background.filled};
          `
        : $backgroundVariant === "alt"
        ? css`
            background-color: ${segment.background.notFilledAlt};
          `
        : css`
            background-color: ${segment.background.notFilled};
          `,
      $isFirst &&
        css`
          border-top-left-radius: ${segment.borderTopLeftRadius.first};
          border-bottom-left-radius: ${segment.borderBottomLeftRadius.first};
        `,
      $isLast &&
        css`
          border-top-right-radius: ${segment.borderTopRightRadius.last};
          border-bottom-right-radius: ${segment.borderBottomRightRadius.last};
        `,
    ];
  }}
`;
